import React from 'react';
import { CommercialLanding } from './components/CommercialLanding';
export function App() {
  return <CommercialLanding data-id="element-0" />;
}